import React from "react";
import PropTypes from "prop-types";
import { DirectUpload } from "@rails/activestorage";
import Dropzone from "react-dropzone";

const FileInfo = ({
  index,
  file,
  onDelete
}) => (
  <div className="attachment">
    <div className="info word-wrap">
      {file.url ? (
        <a href={file.url} className="styled-link" target="_blank">
          {file.name}
        </a>
      ) : (
        file.name
      )}
    </div>

    <div className="actions">
      <span
        className="material-icons pointer-hand styled-link icon-in-row"
        style={{ width: 20 }}
        onClick={() => onDelete(file.id, index)}
      >
        delete
      </span>
    </div>
  </div>
);

class DigiFormAttachments extends React.Component {
  state = {
    files: this.props.files.length ? this.props.files.filter(file => !file._destroy) : []
  };

  render() {
    const {
      accept,
      onDelete
    } = this.props;

    const {
      files
    } = this.state;

    return (
      <div>
        <div className="form-group">
          <label className="control-label">Attachment(s)</label>
          <Dropzone
            className="dropzone dq-dropzone"
            acceptClassName="dq-dropzone-accepted"
            rejectClassName="dq-dropzone-rejected"
            accept={accept === "*/*" ? null : accept}
            multiple={true}
            disablePreview={false}
            onDrop={this.handlerAddFile}
          >
            <div className="grey-text text-center">
              <br />
              <h4>Drop file's here or click to upload.</h4>
              <br />
            </div>
          </Dropzone>
        </div>

        <div className="form-group">
          <div className="attachments">
            {files.filter(file => !file._destroy).map((file, index) => (
              <FileInfo
                key={index}
                index={index}
                file={file}
                onDelete={this.handlerDeleteFile}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  handlerAddFile = (acceptedFiles, rejectedFiles) => {
    const files = this.state.files;
    
    if (rejectedFiles.length > 0) {
      toastr.error(
        `File type not supported for ${rejectedFiles
          .map(file => file.name)
          .join(", ")}`
      );
      return;
    } else {
      files.push(...acceptedFiles)
    }

    this.setState({ files: files });
    this.props.onChange(files, this.props.associationName);
  };

  handlerDeleteFile = (id, index) => {
    if (!confirm("Are you sure you want to delete this file?")) {
      return;
    }

    const files = this.state.files;

    if (id) {
      files[index]._destroy = true;
    } else {
      files.splice(index, 1);
    }

    this.setState({ files: files });
    this.props.onChange(files, this.props.associationName);
  };
}

DigiFormAttachments.propTypes = {
  accept: PropTypes.string,
  files: PropTypes.array,
  onDropFile: PropTypes.func,
  onDelete: PropTypes.func
};

DigiFormAttachments.defaultProps = {
  accept: "application/pdf, image/*",
  files: []
};

export default DigiFormAttachments;
